import { copyToClipboard } from '@/utils/clipboard';
import { buildCaseUrl } from '@/utils/routes';

import type { CaseItem } from '../data/types';

/**
 * Copy the deep-link URL for a workforce-console case to the clipboard and
 * surface a toast. Composes the shared `buildCaseUrl` + `copyToClipboard`
 * utilities; lives in the workforce module because the toast wording is
 * specific to this surface.
 *
 * Accepts the camelCase `CaseItem` slice and converts to the snake_case
 * shape `buildCaseUrl` expects. Missing org/program ids are tolerated —
 * `buildCaseUrl` falls back to the redirect route in that case.
 */
export function copyCaseLink(
  caseItem: Pick<CaseItem, 'id' | 'organizationId' | 'programId'>,
): void {
  void copyToClipboard(
    buildCaseUrl({
      id: caseItem.id,
      organization_id: caseItem.organizationId,
      program_id: caseItem.programId,
    }),
    'Case link copied',
    'Could not copy case link',
  );
}
